export default {
  title: '防骗视伏器',
  btn: '浏览「防骗视伏器」网站',
  c1: 'one_tc.png',
  c2: 'two_tc.png',
  c3: 'three_tc.png',
  c4:"提提您",
  c5:"阁下将打开手机浏览器及「防骗视伏器」的网站",
  c6:"暫不",
  c7:"好的",
  c8:"https://cyberdefender.hk/zh-cn/scameter/",
  c9:"遇上可疑来电，钓鱼讯息和怀疑诈骗陷阱？一站式诈骗陷阱搜寻器「防骗视伏器」帮到你！立即搜寻可疑的网址，电话号码，平台帐户等，参考举报和风险记录，时刻保持警惕！ 点击查看详情和下载",
}
